"use strict";

import module from "./module";

import "./function.spec";

export default module;
